module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_04_6DC79_1SD_G1W.4980e725.png";